<template>
  <div id="home-page" class="travel-page">
    <div class="end-epidemic" :style="{'background-color': messageColor }" v-if="showMessage" @click="saveWorld">
      <span class="close" @click.stop="showMessage = false">x</span>
      {{message}}
      <br>
      <small>
        Click Here
      </small>
    </div>
    <div class="main">
      <header class="darkest-bg">
        <div class="pane">
          <!-- <div class="only-logo">
            <img src="./../assets/only-logo.png" alt="" />
          </div>
          <div class="logo-main">
            <img src="./../assets/full-main.png" alt="" />
          </div> -->
          <div class="logo-main">
            <img src="./../assets/full-logo.png" alt="" />
          </div>
        </div>
        <div class="pane">

          <v-row class="text-center">
            <v-col>
              <router-link class="top-link" to="/">US Epidemic Explorer</router-link>
            </v-col>
            <v-col>
                <router-link class="top-link" to="/us-travel">US Travel Navigator</router-link>
            </v-col>
            <!-- <v-col class="hidden-xs-only">
                <router-link class="top-link" to="/travel">World Travel Navigator</router-link>
            </v-col> -->
          </v-row>
        </div>
      </header>
      
      <section class="main-banner-wrapper">
        <div class="pane">
          <span class="start-label">
            WORLD TRAVEL NAVIGATOR
          </span>
        </div>
      </section>

      <section class="map light-bg">
        <div class="pane pt-0">
          <CovidMapTravel @showBar="showBar" @showProfileHint="showProfileHint"></CovidMapTravel>
        </div>
      </section>
      <!-- <section class="separator dark-bg"></section> -->
      <section class="sign-in light-bg">
        <div class="pane">
          <!-- <div class="container">
            <a href="#" class="arrow down">Up</a>
          </div> -->

          <h2>SIGN UP FOR UPDATES & FREEBIES</h2>
          <div class="instructions">
            Info for countries is continuously updated.<br />
            Sign up for notifications when mandates, reopenings, test sites, and
            research trials are available.<br />
            We send deals for free testing home kits, masks, health or chance
            for you to be paid for research.<br />
            Knowledge is power. Knowing the right info gives you power to take
            control of your life & health.<br />
          </div>
          <div class="form">
            <!-- <div class="inputs">
              <input type="text" v-model="registerDetails.name" id="name" placeholder="Name*" />
              <input type="text" v-model="registerDetails.email" placeholder="Email*" />
              <input type="text" v-model="registerDetails.zip" placeholder="Zip Code*" />
              <input type="text" v-model="registerDetails.county" placeholder="County" />
              <input type="text" v-model="registerDetails.state" placeholder="State" />
            </div> -->
            <v-row>
              <v-col class="d-flex">
                
              <v-text-field label="Name*" class="mx-1" v-model="registerDetails.name" outlined dense hide-details hint=""></v-text-field>
              <v-text-field label="Email*" class="mx-1" v-model="registerDetails.email" outlined dense hide-details hint=""></v-text-field>
              <v-text-field label="Zip Code*" class="mx-1" v-model="registerDetails.zip" outlined dense hide-details hint=""></v-text-field>
              <v-text-field label="Country*" class="mx-1" v-model="registerDetails.country" outlined dense hide-details hint=""></v-text-field>
              <v-text-field label="State, Province or Region*" class="mx-1" v-model="registerDetails.state" outlined dense hide-details hint=""></v-text-field>
              </v-col>
            </v-row>
            <div class="checks">
              <v-checkbox class="mt-1" v-model="registerDetails.freeTest" :hide-details="true" label="Email me info on free tests so I can help prevent the spread of disease"></v-checkbox>
              <v-checkbox class="mt-1" v-model="registerDetails.getPaid" :hide-details="true" label="Email me info about how to get paid for research to help save the world"></v-checkbox>
              <v-checkbox class="mt-1" v-model="registerDetails.receiveUpdates" :hide-details="true" label="Email me info on country mandates and updates so that I can comply or travel"></v-checkbox>
              <v-checkbox class="mt-1" v-model="registerDetails.getVaccineUpdates" :hide-details="true" label="Email me info on vaccine updates and where I can get it"></v-checkbox>
            </div>
            <button id="registerUpdatesBtn" type="submit" @click="register">
              SIGN UP FOR UPDATES
            </button>
          </div>
        </div>
      </section>
      <section class="separator dark-bg"></section>
      <section class="light-bg our-sections">
        <div class="pane">
          <h2 class="mb-3">MILLION PATIENTS CURED</h2>

          <div class="our-section our-mission">
            <div class="img">
              <svg
                preserveAspectRatio="xMidYMid meet"
                data-bbox="0 0 298.185 352.082"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="-23.947801136363637 -3.0006988636363587 346.0806022727273 358.0833977272727"
                role="img"
              >
                <g>
                  <path
                    d="M298.185 264.061l-149.093 88.021L0 264.061V88.021L149.092 0l149.093 88.021v176.04z"
                  ></path>
                </g>
              </svg>
              <div class="img-wrap">
                <svg xmlns:cc="http://creativecommons.org/ns#" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" xmlns:svg="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 800 1000" enable-background="new 0 0 800 800" xml:space="preserve"><g><g><path d="M43.428,639.902c-5.119,0-10.236-1.951-14.143-5.857c-7.811-7.811-7.811-20.475,0-28.285l115.648-115.646    c7.811-7.811,20.475-7.809,28.284,0c7.811,7.811,7.811,20.475,0,28.285L57.57,634.045    C53.665,637.949,48.545,639.902,43.428,639.902z"/></g><g><path d="M69.286,750.715c-5.118,0-10.237-1.953-14.142-5.857c-7.811-7.811-7.811-20.475,0-28.285l120.539-120.539    c7.812-7.811,20.475-7.811,28.284,0c7.811,7.811,7.811,20.475,0,28.285L83.428,744.857    C79.523,748.762,74.404,750.715,69.286,750.715z"/></g><path d="M770.715,29.287c-4.539-4.539-10.977-6.626-17.318-5.604c-2.322,0.374-57.754,9.48-133.296,38.342   c-44.315,16.931-86.421,37.205-125.146,60.262c-48.6,28.936-92.004,62.368-129.006,99.369   c-62.441,62.441-113.465,141.185-151.653,234.041c-3.069,7.465-1.353,16.043,4.354,21.75l37.81,37.811l85.412-85.412   c7.813-7.811,20.475-7.811,28.285,0s7.811,20.475,0,28.285l-85.412,85.412l37.809,37.811c3.826,3.824,8.941,5.857,14.146,5.857   c2.561,0,5.143-0.492,7.604-1.504c92.862-38.191,171.604-89.215,234.042-151.652c37-37.002,70.434-80.406,99.369-129.006   c23.057-38.726,43.332-80.83,60.262-125.146c28.861-75.543,37.969-130.974,38.342-133.297   C777.338,40.267,775.254,33.825,770.715,29.287z M590.644,309.921c-13.431,13.432-31.286,20.829-50.278,20.829   c-0.002,0-0.004,0-0.006,0c-18.994-0.002-36.852-7.398-50.281-20.828c-13.43-13.432-20.826-31.289-20.826-50.283   s7.396-36.852,20.828-50.281c13.43-13.432,31.289-20.829,50.283-20.829s36.85,7.396,50.28,20.827   C618.369,237.082,618.369,282.195,590.644,309.921z"/><g><path d="M180.098,776.572c-5.119,0-10.237-1.951-14.143-5.857c-7.811-7.811-7.811-20.475,0-28.285l115.648-115.648    c7.811-7.809,20.473-7.811,28.283,0s7.811,20.475,0,28.285L194.239,770.715C190.334,774.619,185.216,776.572,180.098,776.572z"/></g><path d="M317.792,229.131l-100.478,19.561c-3.898,0.758-7.483,2.662-10.297,5.466L70.177,390.559   c-6.233,6.213-7.673,15.769-3.546,23.542c3.516,6.621,10.365,10.623,17.66,10.623c1.266,0,2.549-0.121,3.826-0.369l117.368-22.85   C236.441,336.346,274.054,278.624,317.792,229.131z"/><path d="M398.494,594.516l-22.848,117.367c-1.682,8.639,2.48,17.361,10.254,21.486c2.961,1.572,6.178,2.336,9.371,2.336   c5.193,0,10.325-2.021,14.172-5.881L545.842,592.98c2.805-2.813,4.707-6.398,5.467-10.297l19.561-100.475   C521.379,525.945,463.656,563.557,398.494,594.516z"/></g></svg>
                <!-- <img src="./../assets/our-mission.png" /> -->
              </div>
            </div>
            <div class="right">
              <h3>OUR MISSION</h3>
              <div class="details">
                Our mission is to empower humanity to prevent and cure diseases
                by connecting people, info, and services through shared
                technology.<br />
              </div>
            </div>
          </div>

          <div class="our-section data-vision">
            <div class="img">
              <svg
                preserveAspectRatio="xMidYMid meet"
                data-bbox="0 0 298.185 352.082"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="-23.947801136363637 -3.0006988636363587 346.0806022727273 358.0833977272727"
                role="img"
              >
                <g>
                  <path
                    d="M298.185 264.061l-149.093 88.021L0 264.061V88.021L149.092 0l149.093 88.021v176.04z"
                  ></path>
                </g>
              </svg>
              <div class="img-wrap">
                <svg class="svg-data-vision" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 69 86.25" style="enable-background:new 0 0 69 69;" xml:space="preserve"><g><path d="M65.53369,56.72949h-2.40527V23.3125c0-1.61621-1.32031-2.93164-2.94238-2.93164h-7.86121   C51.80139,10.98761,44.01648,3.5,34.49463,3.5c-9.51611,0-17.29639,7.48761-17.81958,16.88086H8.81299   c-1.62207,0-2.94141,1.31543-2.94141,2.93164v33.41699H3.46631c-0.55273,0-1,0.44727-1,1v1.9209   c0,3.22559,2.62402,5.84961,5.84961,5.84961h52.36719c3.22559,0,5.85059-2.62402,5.85059-5.84961v-1.9209   C66.53369,57.17676,66.08643,56.72949,65.53369,56.72949z M34.49463,5.5c8.75684,0,15.88086,7.12402,15.88086,15.88086   c0,8.75586-7.12402,15.87988-15.88086,15.87988c-8.75098,0-15.87012-7.12402-15.87012-15.87988   C18.62451,12.62402,25.74365,5.5,34.49463,5.5z M26.38525,41.72168c0-0.98047,0.79785-1.77832,1.77832-1.77832   s1.77832,0.79785,1.77832,1.77832s-0.79785,1.77734-1.77832,1.77734S26.38525,42.70215,26.38525,41.72168z M7.87158,23.3125   c0-0.52246,0.41309-0.93164,0.94141-0.93164h7.86206c0.39453,7.08234,4.91077,13.07092,11.19604,15.5921   c-1.94446,0.15228-3.48584,1.76587-3.48584,3.74872c0,0.61047,0.1593,1.1792,0.4176,1.69006l-5.28784,4.75342   c-0.58875-0.37927-1.28528-0.60559-2.03601-0.60559c-2.08301,0-3.77832,1.69531-3.77832,3.77832s1.69531,3.77832,3.77832,3.77832   s3.77832-1.69531,3.77832-3.77832c0-0.60565-0.15674-1.17041-0.41113-1.67841l5.29395-4.75891   c0.5863,0.37439,1.27783,0.59845,2.02344,0.59845c0.86157,0,1.64746-0.30127,2.28394-0.7887l6.88501,5.2323   c-0.17297,0.43268-0.27441,0.90167-0.27441,1.39526c0,2.08301,1.69434,3.77832,3.77734,3.77832s3.77832-1.69531,3.77832-3.77832   c0-0.60803-0.15796-1.1748-0.41431-1.68427l5.29138-4.75671c0.58765,0.37689,1.28186,0.60211,2.03015,0.60211   c2.08301,0,3.77832-1.69434,3.77832-3.77734S53.604,37.94336,51.521,37.94336s-3.77832,1.69531-3.77832,3.77832   c0,0.60785,0.15796,1.17438,0.41406,1.68359l-5.29138,4.75653c-0.58765-0.37695-1.28162-0.60223-2.02991-0.60223   c-0.86426,0-1.65186,0.30334-2.28906,0.79358l-6.8811-5.22937c0.17468-0.43439,0.27661-0.90594,0.27661-1.4021   c0-1.18176-0.55688-2.22559-1.40942-2.91901c1.27649,0.29059,2.59912,0.45807,3.96216,0.45807   c9.52185,0,17.30676-7.48663,17.8302-16.87988h7.86121c0.52832,0,0.94238,0.40918,0.94238,0.93164v33.41699H41.68115   c-0.30664,0-0.5957,0.14063-0.78516,0.38086l-2.36719,3.00391h-8.05957l-2.36719-3.00391   c-0.18945-0.24023-0.47852-0.38086-0.78516-0.38086H7.87158V23.3125z M19.25732,51.33789   c0,0.98047-0.79785,1.77832-1.77832,1.77832s-1.77832-0.79785-1.77832-1.77832s0.79785-1.77832,1.77832-1.77832   S19.25732,50.35742,19.25732,51.33789z M42.61377,51.33789c0,0.98047-0.79785,1.77832-1.77832,1.77832   s-1.77734-0.79785-1.77734-1.77832s0.79688-1.77832,1.77734-1.77832C41.83235,49.55957,42.61377,50.39754,42.61377,51.33789z    M49.74268,41.72168c0-0.98047,0.79785-1.77832,1.77832-1.77832s1.77832,0.79785,1.77832,1.77832s-0.79785,1.77734-1.77832,1.77734   S49.74268,42.70215,49.74268,41.72168z M64.53369,59.65039c0,2.12305-1.72754,3.84961-3.85059,3.84961H8.31592   c-2.12305,0-3.84961-1.72656-3.84961-3.84961v-0.9209h22.36523l2.36719,3.00391c0.18945,0.24023,0.47852,0.38086,0.78516,0.38086   h9.03027c0.30664,0,0.5957-0.14063,0.78516-0.38086l2.36719-3.00391h22.36719V59.65039z"/><path d="M48.21826,22.00488c0.28906-0.36426,0.28906-0.87988,0-1.24316c-0.24805-0.31348-6.17773-7.67871-13.7207-7.67871   c-7.53809,0-13.46777,7.36523-13.71582,7.67871c-0.28906,0.36328-0.28906,0.87891,0,1.24316   c0.24902,0.31348,6.17773,7.67285,13.71582,7.67285C42.04053,29.67773,47.96924,22.31836,48.21826,22.00488z M22.88818,21.38184   c1.54395-1.70117,6.21777-6.29883,11.60938-6.29883c5.38086,0,10.06543,4.59863,11.61426,6.2998   c-1.54883,1.7002-6.2334,6.29492-11.61426,6.29492C29.11963,27.67773,24.43506,23.08105,22.88818,21.38184z"/><path d="M39.05811,21.38086c0-2.51367-2.04492-4.55859-4.55859-4.55859c-2.5127,0-4.55762,2.04492-4.55762,4.55859   c0,2.5127,2.04492,4.55762,4.55762,4.55762C37.01318,25.93848,39.05811,23.89355,39.05811,21.38086z M31.94189,21.38086   c0-1.41113,1.14746-2.55859,2.55762-2.55859c1.41113,0,2.55859,1.14746,2.55859,2.55859c0,1.41016-1.14746,2.55762-2.55859,2.55762   C33.08936,23.93848,31.94189,22.79102,31.94189,21.38086z"/></g></svg>
                <!-- <img src="./../assets/our-data-vision.png" /> -->
              </div>
            </div>
            <div class="right">
              <h3>OUR DATA VISION</h3>
              <div class="details">
                Our team of experts identify, curate, validate, and interpret
                data for the public, patients, and providers of healthcare &
                services.<br /><br />
                Our vision is to integrate data for customers and companies
                using our unique data algorithms for faster, easier, and more
                effective decisions.<br /><br />
                We envision a future where consumers will no longer need to
                search for what they want and where companies will be able to
                easily find more customers to serve.<br /><br />
              </div>
            </div>
          </div>

          <div class="our-section">
            <div class="img technology">
              <svg
                preserveAspectRatio="xMidYMid meet"
                data-bbox="0 0 298.185 352.082"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="-23.947801136363637 -3.0006988636363587 346.0806022727273 358.0833977272727"
                role="img"
              >
                <g>
                  <path
                    d="M298.185 264.061l-149.093 88.021L0 264.061V88.021L149.092 0l149.093 88.021v176.04z"
                  ></path>
                </g>
              </svg>
              <div class="img-wrap">
                <svg class="svg-our-technology" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision;text-rendering:geometricPrecision;image-rendering:optimizeQuality;" viewBox="0 0 50000 62500" x="0px" y="0px" fill-rule="evenodd" clip-rule="evenodd">
                  <g><path class="fil0" d="M11967.46 12828.8c-648.44,660.28 -638.73,1734.13 21.55,2382.58 660.27,648.44 1734.13,638.73 2382.57,-21.55 648.45,-660.27 638.74,-1734.13 -21.54,-2382.57 -660.28,-648.45 -1734.13,-638.74 -2382.58,21.54zm32502.95 21651.7c-613.37,624.56 -1629.2,633.74 -2253.76,20.38 -624.56,-613.37 -633.74,-1629.2 -20.38,-2253.76 613.37,-624.56 1629.2,-633.74 2253.76,-20.38 624.56,613.37 633.74,1629.2 20.38,2253.76zm-648.86 -637.23c263.27,-268.09 259.33,-704.39 -8.75,-967.67 -268.09,-263.27 -704.39,-259.33 -967.67,8.75 -263.27,268.09 -259.33,704.39 8.75,967.67 268.09,263.27 704.39,259.33 967.67,-8.75zm-1199.01 -25244.86c-784.58,798.89 -2083.97,810.64 -2882.85,26.06 -798.89,-784.57 -810.64,-2083.96 -26.07,-2882.85 784.54,-798.91 2083.98,-810.62 2882.85,-26.06 798.89,784.57 810.64,2083.96 26.07,2882.85zm-648.86 -637.24c434.48,-442.41 427.97,-1162.27 -14.44,-1596.75 -442.39,-434.47 -1162.29,-428 -1596.76,14.43 -434.48,442.42 -427.97,1162.28 14.44,1596.76 442.41,434.49 1162.27,427.98 1596.76,-14.44zm6531.95 19665.25c-613.37,624.56 -1629.2,633.74 -2253.76,20.38 -624.56,-613.37 -633.74,-1629.2 -20.37,-2253.76 613.36,-624.56 1629.19,-633.74 2253.75,-20.38 624.56,613.37 633.75,1629.2 20.38,2253.76zm-648.86 -637.23c263.28,-268.09 259.33,-704.39 -8.75,-967.67 -268.08,-263.28 -704.38,-259.33 -967.66,8.75 -263.28,268.09 -259.34,704.39 8.75,967.67 268.08,263.27 704.38,259.33 967.66,-8.75zm-42327.2 -11142.42c613.37,-624.56 1629.2,-633.74 2253.76,-20.38 624.56,613.37 633.74,1629.2 20.38,2253.76 -613.37,624.56 -1629.2,633.74 -2253.76,20.38 -624.56,-613.37 -633.74,-1629.2 -20.38,-2253.76zm648.86 637.23c-263.27,268.09 -259.33,704.39 8.75,967.67 268.09,263.27 704.39,259.33 967.67,-8.75 263.27,-268.09 259.33,-704.39 -8.75,-967.67 -268.09,-263.28 -704.39,-259.33 -967.67,8.75zm1177.86 24917.61c784.54,-798.91 2083.98,-810.62 2882.85,-26.07 798.89,784.58 810.64,2083.97 26.07,2882.86 -784.57,798.89 -2083.96,810.63 -2882.85,26.06 -798.87,-784.55 -810.66,-2084 -26.07,-2882.85zm648.86 637.23c-434.5,442.4 -427.95,1162.29 14.44,1596.76 442.41,434.48 1162.27,427.98 1596.76,-14.44 434.48,-442.41 427.97,-1162.27 -14.44,-1596.75 -442.39,-434.47 -1162.29,-428 -1596.76,14.43zm-6510.8 -19337.99c613.37,-624.56 1629.2,-633.74 2253.76,-20.38 624.56,613.37 633.74,1629.2 20.37,2253.76 -613.36,624.56 -1629.19,633.74 -2253.75,20.38 -624.56,-613.37 -633.75,-1629.2 -20.38,-2253.76zm648.86 637.23c-263.28,268.09 -259.33,704.39 8.75,967.67 268.08,263.27 704.38,259.33 967.66,-8.75 263.28,-268.09 259.34,-704.39 -8.75,-967.67 -268.08,-263.27 -704.38,-259.33 -967.66,8.75zm17311.48 -3693.44l-4500.98 -3752.03c-804.07,762.7 -2014.1,928.12 -2991.86,413.46l-2651.37 6702.22c1384.47,431.95 2157.27,1934.77 1680.58,3320.76l2616.24 1340.37c241.6,-437.12 629.78,-781.73 1093.51,-968.31l-774.73 -4044.73c-467.63,22.45 -919.38,-149.35 -1253.65,-477.63 -656.05,-644.3 -665.7,-1710.84 -21.4,-2366.9 644.3,-656.06 1710.84,-665.7 2366.9,-21.4 276.42,271.46 438.64,615.34 486.2,971.71l3556.32 47.47c35.45,-407.11 166.75,-807.65 394.24,-1164.99zm-4146.84 -4165.73l4485.95 3739.52 0.18 -0.18c286.48,-291.71 625,-501.37 986.23,-628.75l-744.49 -2035.57c-663.15,164.76 -1365.13,-24.61 -1854.86,-505.56 -771.21,-757.39 -782.57,-2011.29 -25.16,-2782.5 757.39,-771.23 2011.29,-782.55 2782.5,-25.16 771.23,757.41 782.55,2011.25 25.16,2782.5 -128.43,130.78 -270.67,239.79 -422.09,327.04l772.66 2112.58c790.06,-101.07 1578.84,162.61 2148.72,722.25 1016.85,998.62 1031.76,2651.82 33.17,3668.67 -174.32,177.48 -367.89,324.6 -574.11,441.29l968.13 2647.02c868.74,-208.26 1784.62,42.96 2424.8,671.67 572.5,562.25 850.55,1351.73 759.68,2146.77l3101.51 760.51c122.85,-339.92 319.06,-659.5 588.89,-934.24 1101.33,-1121.43 2948.36,-1003.26 3904.74,232.39l3702.07 -2943.71c-113.8,-418.28 -120.67,-864.77 -20.1,-1286.4l-3377.42 -953.36c-93.18,210.86 -225.21,408.81 -396.28,583.01 -757.45,771.23 -2011.26,782.55 -2782.5,25.16 -740.38,-727.15 -785.41,-1921.42 -100.92,-2700.9l-2004.73 -2563.11c-1013.44,645.91 -2350.79,505.78 -3210.45,-338.48 -1016.81,-998.62 -1031.79,-2651.82 -33.17,-3668.67 175.93,-179.14 371.51,-327.31 579.91,-444.53l-1811.88 -2846.98c-1308.1,339.76 -2671.32,-383.9 -3110.61,-1674.84l-6639.1 2791.52c447.18,846.53 387.52,1891.56 -156.43,2681.04zm-1902.27 12697.8l-2644.62 -1354.88c-324,537.99 -834.06,943.59 -1433.37,1135.09l2820.58 6632.77c543.66,-292.3 1179.33,-379.83 1781.55,-248.9l735.09 -3611.84c-244.96,-103.73 -474.89,-254.38 -676.2,-452.08 -556.56,-546.61 -776.9,-1348.14 -583.03,-2100.16zm1785.04 2700.26l-740.14 3636.53c268.59,122.13 520.81,292.49 743.54,511.22 790.88,776.72 999.69,1977.28 522.01,2973.04l6813.55 2353.51c122.14,-244.79 281.9,-467.66 471.75,-660.97 998.48,-1016.63 2651.97,-1031.58 3668.67,-33.17 405.87,398.61 681.45,929.89 756.13,1524.44l6844.95 -2826.3c-870.38,-1015.26 -817,-2549.38 120.61,-3504.1 868.19,-884.03 2261.95,-1028.36 3290.29,-341.09l2466.55 -6826.02c-673.76,-196.25 -1240.71,-660.7 -1568.26,-1280.01l-3623.47 2881.23c468.37,979.92 273.71,2159.08 -490.24,2936.99 -998.61,1016.82 -2651.85,1031.77 -3668.67,33.17 -587.23,-576.73 -863.67,-1392.02 -752.41,-2204.79l-3089.57 -757.59c-188.95,562.18 -568.68,1044.52 -1068.5,1362.35l1902.8 3835.83c669.95,-251.75 1431.88,-92.37 1944.68,411.24 723.89,710.92 734.53,1887.78 23.61,2611.68 -710.9,723.87 -1887.8,734.51 -2611.68,23.61 -799,-784.68 -713.96,-2100.97 167.3,-2781.18l-1914.4 -3859.23c-614.06,227.43 -1302.55,213.43 -1906.68,-39.84l-1358.57 2520.86c115.49,81.06 225.88,172.6 329.86,274.71 1016.84,998.63 1031.75,2651.83 33.17,3668.67 -998.63,1016.81 -2651.83,1031.8 -3668.67,33.17 -1016.81,-998.62 -1031.8,-2651.82 -33.17,-3668.67 745.83,-759.44 1885.92,-984.9 2862.3,-571.96l1357.75 -2519.35c-1307.38,-911.35 -1495.3,-2801.95 -369.75,-3948.05 217.71,-221.68 465.47,-395.96 730.43,-522.78l-955.4 -2612.19c-800.38,250.15 -1680.37,98.4 -2348.92,-412.53l-3115.08 3989.7c28.75,25.43 56.99,51.72 84.68,78.92 1504.34,1477.37 218.69,4018.99 -1851.05,3708.95zm3879.44 -9523.48l-3582.05 -47.82c-109.02,560.55 -499.51,1028.63 -1030.25,1236.95l770.02 4020.11c437.58,-57.9 884.7,17.72 1278.32,218.83l3168.37 -4057.95c-342.29,-398.73 -543.94,-877.3 -604.41,-1370.12zm6664.21 -9869.49l1798.93 2826.64c908.18,-278.83 1900.47,-39.87 2581.43,628.89 248.89,244.42 438.07,526.74 567.35,828.72l2904.05 -1110.49c-232.65,-667.92 -181.25,-1415.14 143.4,-2044.33l-6717.5 -2594.14c-219.67,634.21 -680.01,1160.77 -1277.66,1464.71zm4381.15 7156.53l1991.32 2545.95c398.75,-257.86 879.34,-361.39 1348.4,-293.99l1279.06 -4845.2c-373.59,-217.01 -690.63,-527.51 -915.38,-896.49l-2976.39 1138.15c164.65,839.7 -92.71,1706.33 -694.63,2319.25 -10.7,10.9 -21.52,21.64 -32.38,32.33zm5121.74 -2369.16l-1259.75 4772.04c207.91,92.97 403.12,223.84 575.16,392.79 446.39,438.36 656.09,1058.83 570.08,1676.45l3410.57 962.72c309.28,-646.89 875.82,-1141.05 1560.68,-1356.99l-2823.87 -6633.2c-620.14,335.58 -1362.54,402.48 -2032.87,186.19zm-7465.09 19291.96c-360.74,367.32 -355.34,964.84 11.99,1325.58 367.32,360.74 964.84,355.34 1325.58,-11.99 360.76,-367.34 355.36,-964.82 -11.99,-1325.58 -367.34,-360.76 -964.82,-355.36 -1325.58,11.99zm4646.86 -13464.74c-407.25,414.68 -401.13,1089.14 13.53,1496.41 414.7,407.23 1089.12,401.15 1496.41,-13.53 407.22,-414.66 401.16,-1089.18 -13.53,-1496.41 -414.68,-407.24 -1089.16,-401.15 -1496.41,13.53zm-19119.04 -1649.51c-294.13,299.51 -289.73,786.67 9.78,1080.81 299.48,294.12 786.68,289.71 1080.8,-9.78 294.12,-299.48 289.71,-786.68 -9.77,-1080.8 -299.51,-294.14 -786.67,-289.73 -1080.81,9.77zm5504.67 -6545.98c-407.26,414.66 -401.13,1089.18 13.53,1496.41 414.68,407.24 1089.14,401.13 1496.41,-13.53 407.22,-414.7 401.14,-1089.16 -13.53,-1496.41 -414.66,-407.23 -1089.18,-401.16 -1496.41,13.53zm12609.02 15320.9c-648.45,660.28 -638.74,1734.13 21.54,2382.58 660.28,648.44 1734.13,638.73 2382.58,-21.55 648.44,-660.27 638.73,-1734.13 -21.55,-2382.57 -660.27,-648.45 -1734.13,-638.74 -2382.57,21.54zm-11969.06 5099.49c-648.45,660.28 -638.74,1734.14 21.54,2382.58 660.28,648.45 1734.13,638.74 2382.58,-21.54 648.44,-660.28 638.73,-1734.13 -21.55,-2382.58 -660.27,-648.44 -1734.13,-638.73 -2382.57,21.54zm-4818.71 -4695.52c1179.75,1158.62 2981.5,-629.78 1778.67,-1811.06 -1189.71,-1168.29 -2968.2,642.76 -1778.67,1811.06zm8669.02 -2343.84c-648.45,660.28 -638.74,1734.14 21.54,2382.58 571.09,560.86 1451.61,629.34 2098.63,210.36 895.52,-579.99 1030.66,-1859.99 262.4,-2614.48 -660.28,-648.44 -1734.13,-638.73 -2382.57,21.54zm3799.99 -11674.2c-648.44,660.28 -638.73,1734.14 21.55,2382.58 660.27,648.44 1734.13,638.74 2382.57,-21.54 648.45,-660.28 638.74,-1734.13 -21.54,-2382.58 -660.28,-648.44 -1734.13,-638.73 -2382.58,21.54zm-6651.98 4245.55c-648.44,660.28 -638.73,1734.13 21.54,2382.58 660.28,648.44 1734.14,638.73 2382.58,-21.54 648.45,-660.28 638.74,-1734.14 -21.54,-2382.58 -660.28,-648.45 -1734.13,-638.74 -2382.58,21.54zm14597.71 15632.92c-648.44,660.28 -638.73,1734.14 21.54,2382.58 660.28,648.45 1734.14,638.74 2382.58,-21.54 648.45,-660.28 638.74,-1734.13 -21.54,-2382.58 -660.28,-648.44 -1734.13,-638.73 -2382.58,21.54zm3350.49 -274.38c688.68,1014.63 563.31,2396.09 -297.51,3272.65 -783.87,798.18 -1998.54,1002.8 -2998.25,509.74l-7739.94 3195.83c-118.24,433.34 -346.08,821.87 -652.17,1133.56 -998.48,1016.63 -2651.97,1031.58 -3668.67,33.17 -570.03,-559.85 -847.57,-1343.37 -761.08,-2135.62l-7118.74 -2458.92c-1007.97,950.37 -2607.55,933.04 -3596.17,-37.86 -970.81,-953.42 -1035.74,-2517.85 -145.85,-3546.47l-3021.18 -7104.51c-3241.78,-179.13 -3210.15,-4985.95 -13.52,-5179.73l2839.48 -7177.76c-889.45,-1013.91 -844.38,-2563.74 101.16,-3526.53 959.19,-976.69 2534.82,-1035.51 3562.42,-131.87l7086.14 -2979.5c47.09,-1386.87 1180.86,-2491.68 2569.26,-2504.23 1415.47,-12.8 2580.52,1112.08 2616.81,2526.84l7155.99 2763.47c1012.66,-904.81 2575.07,-866.6 3544.4,85.36 968.76,951.39 1035.8,2511.77 150.77,3540.7l3027.27 7110.98c644.98,38.37 1227.42,312.8 1661.11,738.68 1016.63,998.48 1031.58,2651.97 33.17,3668.67 -426.14,433.88 -1003.87,718.87 -1648.41,768.68l-2686.49 7434.67zm-3535.69 -20209.4c660.28,648.44 1734.13,638.73 2382.58,-21.55 648.44,-660.27 638.74,-1734.13 -21.54,-2382.57 -660.28,-648.45 -1734.13,-638.74 -2382.58,21.54 -648.44,660.28 -638.73,1734.13 21.54,2382.58zm-22659.6 23073.08c660.27,648.45 1734.13,638.74 2382.57,-21.54 648.45,-660.27 638.74,-1734.13 -21.54,-2382.57 -660.27,-648.45 -1734.13,-638.74 -2382.57,21.54 -648.45,660.27 -638.74,1734.13 21.54,2382.57zm14048.81 -28922.78c-8.42,-930.5 -769.42,-1677.87 -1699.92,-1669.46 -930.5,8.41 -1677.87,769.42 -1669.46,1699.92 20.29,2243.44 3389.2,2161.9 3369.38,-30.46zm-2572.83 33555.19c660.18,648.32 1734.22,638.61 2382.58,-21.54 646.39,-658.19 644.44,-1728.49 -21.55,-2382.58 -660.18,-648.32 -1734.22,-638.61 -2382.57,21.54 -648.46,660.3 -638.72,1734.12 21.54,2382.58zm17218.52 -15832.5c465.24,-4.21 884.74,-196.59 1186.83,-504.17 648.32,-660.19 638.61,-1734.22 -21.54,-2382.58 -307.6,-302.07 -730.51,-486.83 -1195.75,-482.63 -2200.63,19.9 -2203.27,3389.57 30.46,3369.38zm-32337.9 292.38c2200.62,-19.9 2203.26,-3389.58 -30.47,-3369.38 -2200.62,19.9 -2203.26,3389.57 30.47,3369.38z"/></g></svg>
                <!-- <img src="./../assets/our-technology.png" /> -->
              </div>
            </div>
            <div class="right">
              <h3>OUR TECHNOLOGY</h3>
              <div class="details">
                Our predictive algorithm and analytics technology has been
                developed, implemented, and improved over the last 20 years in
                the regulated healthcare industry.<br /><br />
                Through innovative design, our architecture and technology is
                intelligently crafted to aggregate information meaningfully in a
                scalable way.<br /><br />
                Our artificial intelligence engine learns from patterns of
                behavior and applies the machine learning to enable faster
                decision-making.<br /><br />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="separator dark-bg"></section>
      <footer class="light-bg">
        <div class="pane">
          <div class="menu">
            <h4>EXPLORE</h4>
            <a href="/#/" class="small">EXPLORER</a>
            <!-- <a href="/#/about" class="small">ABOUT US</a> -->
          </div>
          <div>
            <h4>CONTACT US</h4>
            <a class="small">info@millionpatientscured.com</a>
          </div>
          <div class="social-media">
            <h4>FOLLOW US</h4>
            <a href="http://www.facebook.com/millionpatientscured"
              ><img src="./../assets/facebook.png"
            /></a>
            &nbsp;
            <a href="http://www.instagram.com/millionpatientscured"
              ><img src="./../assets/instagram.png"
            /></a>
          </div>
        </div>
      </footer>
      <section class="copyright lightest-bg">
        <div class="pane">
          © 2020 MILLION PATIENTS CURED
        </div>
      </section>
    </div>

    <v-snackbar v-model="snackbar" :timeout="2000" :color="snackbarColor">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <div class="notification-bar hidden sign-up-yes" @click="gotoSignUp()">
      <button class="close" @click.stop="hideBar">x</button>
      <span class="message">Click here to be notified when reopening changes on your state, province or region.</span
      >
      <!-- <button class="sign-up sign-up-yes">Yes</button> -->
      <!-- <button class="sign-up sign-up-no">No</button> -->
    </div>
    
  </div>
</template>

<script>
import CovidMapTravel from "./../components/CovidMapTravel.vue"
import $ from "jquery"
import _ from "lodash"
import countyList from '../county-list'

export default {
  name: "HomePage",
  components: {
    CovidMapTravel
  },
  props: {
  },
  created() {
    // debugger
    // $(".notification-bar .close").on("click", this.hideBar)
    // $(".sign-up-yes").on("click tap", () => {
    //   $("#name").focus()
    //   this.hideBar()
    // })
    setTimeout(() => this.showMessage = true, 3000)
    this.states = _.uniq(countyList.map(d => d.state))
  },

  data: () => ({
    states: [],
    counties: [],
    registerDetails: {
      freeTest: true,
      getPaid: true,
      receiveUpdates: true,
      getVaccineUpdates: true,
    },
    snackbarText: '',
    snackbar: false,
    snackbarColor: 'info',
    barAction: null,
    showMessage: false,
    messageColor: [
      "#ff8319",
      "#0bb1f0",
      "#f01671"][_.random(0,2)],
      
    message: "Sign up for travel & vaccine updates",
    // message: [
    //   "Sign up for travel and vaccine updates"
    //   // "Help end this epidemic earlier",
    //   // "Save the world from COVID-19"
    //   ][_.random(1)]
  }),
  
  watch: {
    "registerDetails.state"(newValue, oldValue) {
      console.log({oldValue, newValue})
      if (oldValue && oldValue != newValue) {
        this.registerDetails.county = ""
      }
      this.counties = countyList
        .filter(d => d.state == newValue)
        .map(d => d.county)
    }
  },
  methods: {
    showBar(message) {
      if (message) {
        $(".notification-bar .message").text(message)
        this.barAction = 'signUp'
      }
      $(".notification-bar").removeClass("hidden")
    },
    showProfileHint(message) {
      if (message) {
        $(".notification-bar .message").text(message)
        this.barAction = 'profile'
      }
      $(".notification-bar").removeClass("hidden")
    },
    saveWorld() {

      // let target = document.getElementById("name")
      // if (target && target.offsetTop) {
      //   window.scrollTo(0, target.offsetTop)
      // // $("#name").focus()
      // }
      this.showMessage = false;
      this.registerDetails.freeTest = true;
      this.registerDetails.getPaid = true;
      this.registerDetails.receiveUpdates = true;
      document.querySelector('.sign-in').scrollIntoView({ 
        behavior: 'smooth' 
      });

      setTimeout(() => $("#name").focus(), 700)
    },
    gotoSignUp() {
      if (this.barAction == 'signUp') {
        $("#name").focus()
        this.hideBar()
      } else if (this.barAction == 'profile') {
        this.hideBar()

        let target = document.getElementById("profilesAccordion")
        if (target && target.offsetTop) {
          window.scrollTo(0, target.offsetTop)
        }
      } else {
        
      }
    },
    hideBar: function() {
      $(".notification-bar").addClass("hidden")
    },
    register() {

      let details = this.registerDetails

      fetch(
        "https://testsites.millionpatientscured.com:5000/api/subscription",
        {
          // fetch('http://localhost:5000/api/subscription', {
          method: "post",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(details)
        }
      )
        .then(() => {
          console.log("success registering")

          this.registerDetails = {
            freeTest: true,
            getPaid: true,
            receiveUpdates: true,
          }

          this.snackbar = true
          this.snackbarText = "Thanks for registering!"
          this.snackbarColor = "info"
        })
        .catch(function(error) {
          console.log("error registering")
          this.snackbar = true
          this.snackbarText = "Error registering"
          this.snackbarColor = "error"
          console.log(error)
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

#home-page {
  // background: #ffffff;
  margin: 0;
  color: #333;
  /* font-family: Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"; */
}
.travel-page {
  .end-epidemic {
    position: fixed;
    top: 30px;
    right: 30px;
    width: 310px;
    border-radius: 3px;
    background: rgb(218,135,218);
    // background: #55b466;
    padding: 10px;
    z-index: 6;
    color: white;
    font-weight: 600;
    cursor: pointer;
    animation: seeMe 0.6s infinite alternate ease-in-out;
    &:hover {
      opacity: 1;
      animation: none;
    }
    .close {
      position: absolute;
      right: 4px;
      transform: translateY(-50%);
      top: 50%;
      font-size: 14px;
      background: #00000017;
      text-align: center;
      line-height: 46px;
      border-radius: 3px;
      padding: 3px;
      height: 60px;
      width: 20px;
      &:hover {
        background: #00000026;
      }
    }
  }

  @keyframes seeMe {
    0% {
      transform: translateY(0);
      opacity: 0.9;
    }
    100% {
      transform: translateY(-0.2em);
      opacity: 1;
    }
  }

  // html {
  //   box-sizing: border-box;
  // }
  // *, *:before, *:after {
  //   box-sizing: inherit;
  // }

  /* ---- reset ---- */
  canvas {
    display: block;
    vertical-align: bottom;
  }

  // header h1 {
  //   margin: 0;
  //   font-weight: normal;
  //   font-size: 40px;
  // }

  h2 {
    margin-top: 10px;
    font-size: 36px;
    font-weight: normal;
  }

  .pane {
    padding: 10px 0;
    max-width: 980px;
    margin: 0 auto;
  }

  .social-media img {
    filter: invert(1);
  }

  // .darkest-bg {
  //   background: #00000038;
  // }

  // .dark-bg {
  //   background: #0000001c;
  // }

  // .light-bg {
  //   background: #00000008;
  // }

  // .lightest-bg {
  //   background: #ffffff57;
  // }

  header {
    width: 100%;
    padding-top: 13px !important;
    padding-bottom: 24px !important;
    letter-spacing: 4px;
    position: absolute;
    z-index: 1;
  }

  header {
    img {
      vertical-align: middle;
      border-style: none;
      width: 100%;
      max-width: 450px;
      z-index: 1;
    }
    .only-logo {
      padding-right: 6px;
      display: inline-block;
    }
    .only-logo img {
      max-width: 68px;
      height: auto;
    }
    .logo-main {
      display: inline-block;
    }
    .logo-main img {
      filter: invert;
    }
  } 

  header .pane {
    display: flex;
    align-items: center;
  }


  .main-banner-wrapper::before {
    content: " ";
    background: #000 url(../assets/main-img.jpg);
    background-size: cover;
    background-position: center -217px;
    background-repeat: no-repeat;
    /* background-origin: content-box; */
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 0;
    background-attachment: fixed;
    opacity: 0.5;
  }

  .main-banner-wrapper {
    position: relative;
    padding-top: 107px;
    margin-bottom: -697px;
    height: 873px;
    .pane {
      position: relative;

    }
  }
  .main-banner {
    /* background: red; */
    /* width: 700px; */
    height: 300px;
    padding: 45px 33px;
    position: relative;
    h2 {
      margin-top: 75px;
      line-height: 1;
    }
  }

  span.start-label {
    bottom: 28px;
    font-size: 30px;
    display: block;
    width: 100%;
    text-align: center;
  }

  section {
    font-size: 16px;
  }

  .separator {
    background: none !important;
    height: 45px;
  }

  // .main-banner:hover span.start-label {
  //   right: 60px;
  //   opacity: 1;
  //   font-size: 22px;
  // }

  .main-banner h2 small {
    font-size: 30px;
    margin-left: 55px;
  }

  section.main-instructions {
    text-align: center;
    padding: 10px;
    line-height: 25px;
    font-size: 16px;
  }

  .sign-in .instructions {
    margin: 10px 0 23px;
    display: inline-block;
    line-height: 19px;
  }

  header,
  .sign-in,
  .our-sections {
    padding: 0 10px;
  }

  :focus {
    outline: none;
  }

  input[type="text"] {
    border-radius: 3px;
    border: none;
    margin: 0 2px;
    font-size: 17px;
    padding: 6px 4px;
    font-style: italic;
  }

  .modal {
    color: #333;
  }
  .modal-footer,
  .modal-header {
    border: none;
  }

  #registerUpdatesBtn {
    width: 100%;
    background: #1565c0;
    margin: 8px 0px 12px;
    height: 39px;
    font-size: 15px;
    border: none;
    border-radius: 3px;
    color: #fff;
    // box-shadow: rgba(0, 0, 0, 0.27) 0px 2px 9px 4px;
  }

  .inputs {
    display: flex;
  }
  .inputs input {
    background: white;
    width: 100%;
    border: 1px solid #bbb;
  }

  .img {
    width: 160px;
    min-width: 160px;
    position: relative;
    margin-top: 12px;
  }

  .img svg {
    fill: none;
    stroke-width: 7px;
    // filter: drop-shadow(2px 4px 6px #00000099);
  }

  .img .img-wrap {
    width: 160px;
    position: absolute;
    top: 0;
    left: 0;
    margin-left: 0;
    height: 100%;
    text-align: center;
  }

  .img img {
    margin-top: -38px;
    padding-top: 50%;
    transform: scale(1.12);
    line-height: 166px;
    vertical-align: middle;
    filter: drop-shadow(2px 4px 6px #00000099);
  }

  .our-section {
    display: flex;
    font-size: 15px;
    margin-bottom: 54px;
  }
  .our-section .right {
    padding-left: 30px;
  }

  .our-section h3 {
    font-size: 29px;
    font-weight: normal;
    margin: 3px 0 8px 0;
  }

  .our-section.our-mission {
    font-size: 20px;
  }

  .our-section .details {
    padding-left: 30px;
    max-width: 619px;
  }
  .our-section.our-mission .details {
    max-width: 527px;
  }

  footer .pane {
    display: flex;
  }
  footer .pane > div {
    width: 100%;
    padding-left: 20px;
  }

  footer {
    min-height: 170px;
    padding-top: 25px;
    padding-bottom: 54px;
    font-size: 14px;
  }

  footer img {
    max-width: 40px;
  }

  section.copyright {
    text-align: center;
    font-size: 14px;
    border-top: 1px solid #333;
    padding: 6px 0;
  }

  footer h4 {
    border-top: 4px solid #333;
    width: 165px;
    padding-top: 9px;
    font-size: 16px;
    font-weight: normal;
  }

  footer .small {
    font-size: 13px;
    color: #333;
  }


  .notification-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #0066ff;
    color: white;
    padding: 8px 14px 6px;
    font-size: 14px;
    transition: bottom linear 1200ms;
    cursor: pointer;
    z-index: 5;
  }

  /* .notification-bar .sign-up {
    background: transparent;
    border: 1px solid white;
    border-radius: 3px;
    color: white;
    padding: 0px 6px;
    font-size: 14px;
  } */

  .notification-bar .close {
    font-size: 18px;
    line-height: 13px;
    height: 26px;
    width: 26px;
    padding: 0 0 4px 0;
    float: right;
  }

  .notification-bar.hidden {
    bottom: -300px;
  }


  .our-mission {
    .img svg {
      stroke: #7dbbd4;
    }
    .img-wrap svg {
      stroke-width: 23px;
      width: 101px;
      position: relative;
      top: 35px;
    }
  }

  .data-vision {
    .img svg {
      stroke: #da87da;
    }
    .svg-data-vision {
      stroke-width: 0;
      fill: #da87da;
      top: 7px;
      width: 127px;
      position: relative;
    }
  }

  .technology {
    svg {
      stroke: #73d496;
    }
    .svg-our-technology {
      fill: #73d496;
    }
  }

  .menu a.small {
    text-decoration: none;
    display: block;
  }


  @media only screen and (max-width: 600px) {
  .end-epidemic {
    display: none;
    position: fixed;
    left: 30px;
    width: initial;
    top: initial;
    bottom: 30px;
  }

    .sign-in,
    .our-sections {
      padding: 0;
      h2 {
        font-size: 24px;
      }
    }


    .main {
      overflow-x: hidden;
    }
    // header h1 {
    //   text-align: center;
    //   font-size: 17px;
    // }

    header {
      padding: 0 10px 10px !important;
    }

    .main-banner h2 {
      text-align: center;
      margin-top: -25px;
      margin-left: -33px;
      margin-right: -33px;
      font-size: 16px;
    }

    .main-banner {
      margin-top: 38px;
      height: 90px;
    }

    .main-banner h2 small {
      font-size: 16px;
      margin: 0;
    }
    .main-banner-wrapper {
      margin-bottom: 5px;
      height: auto;
    }
    .main-banner-wrapper::before {
      background-attachment: inherit;
      background-position: center center;
    }

    span.start-label {
      opacity: 1;
      font-size: 12px;
      display: block;
      text-align: center;
      width: 100%;
      right: 0;
      left: 0;
      padding: 0 7%;
      bottom: 0px;
    }

    section.main-instructions {
      font-size: 12px;
      line-height: 17px;
    }

    h2 {
      text-align: center;
    }

    .instructions {
      text-align: center;
      font-size: 13px;
      padding: 0 23px;
    }

    .inputs {
      flex-direction: column;
    }

    .inputs input[type="text"] {
      margin: 7px 0;
      height: 40px;
      font-size: 18px;
      padding: 6px 10px;
      /* border-radius: 16px; */
    }

    #registerUpdatesBtn {
      margin: 8px 0px 12px;
      height: 40px;
    }

    // button {
    //   margin: 10px -1px;
    //   height: 47px;
    //   font-size: 17px;
    //   border-radius: 5px;
    // }

    .form {
      padding: 0 36px;
    }

    h2 {
      font-size: 20px;
    }

    .our-section {
      padding: 0 10px;
    }

    .our-section .details {
      padding: 0;
      font-size: 12px;
    }

    .img {
      /* min-width: 100px; */
      /* width: 100px; */
      transform: scale(0.5) translate(-58px, -46px);
    }

    .our-section.our-mission {
      margin-bottom: 0;
    }
    .our-section {
      margin-bottom: 20px;
    }
    .our-section .right {
      padding-left: 0;
      margin-left: -57px;
    }


    .our-section h3 {
      font-size: 21px;
    }
    footer .pane {
      flex-direction: column;
      text-align: center;
    }

    footer h4 {
      display: none;
    }

    footer a.small {
      font-size: 14px;
      margin: 10px 0;
      display: inline-block;
    }

    footer {
      padding-top: 1px;
      padding-bottom: 0;
      min-height: 141px;
    }

    footer .menu h4 {
      display: block;
      margin: 0;
      text-align: center;
      border-top: none;
      width: 100%;
    }
    footer .menu a.small {
      display: none;
    }
  }
}
</style>
